// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LICENSES {
    // Handsontable license active from Jan 26, 2026 through Jan 30, 2027
    export const HandsOnTable = '41465-b2109-0d620-94e05-17014';
}
